import { Divider } from "antd";
import { useTranslation } from "react-i18next";
import { Alert } from "../api/models";
interface BeaconActiveErrorsTooltipProps {
  errors: Alert[] | undefined;
}

export function ActiveErrorsLabel(props: { errors: Alert[] | undefined }) {
  const { t } = useTranslation();

  const warningLabel = props.errors?.length
    ? t("beacon:active-alerts-tooltip", { count: props.errors.length })
    : undefined;

  return <>{warningLabel}</>;
}

export function BeaconActiveErrorsTooltip(
  props: BeaconActiveErrorsTooltipProps
) {
  return (
    <div>
      <span style={{ fontWeight: "bold" }}>
        <ActiveErrorsLabel errors={props.errors} />
      </span>
      <>
        <Divider
          style={{ margin: "0.25em  0", backgroundColor: "white" }}
          type="horizontal"
        />
        {props.errors?.map((e, i) => (
          <div key={i}>{e.alert}</div>
        ))}
      </>
    </div>
  );
}
